export default __webpack_public_path__ + "static/media/LargeSBCTAcceptableMovementEdited.7b2bc306.png";